<template>
	<a class="btn btn_blue" href="#" @click.prevent="onClickReviewButton">Оставить отзыв</a>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
	name: 'ReviewFormButton',
	props: {
		productId: {
			type: [Number, String],
			required: true,
		},
	},
	methods: {
		...mapMutations({
			setReviewProductId: 'setReviewProductId',
		}),
		...mapActions({
			requestReviewPermission: 'requestReviewPermission',
		}),
		async onClickReviewButton() {
			this.setReviewProductId(this.productId);
			const isReviewAllowed = await this.requestReviewPermission(this.productId);

			if (isReviewAllowed) {
				window.openCompactModal('add-score-popup');
			}
		},
	},
}
</script>
